import { render, staticRenderFns } from "./QuestionLayoutA.vue?vue&type=template&id=62b5e78e&scoped=true&"
import script from "./QuestionLayoutA.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutA.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutA.vue?vue&type=style&index=0&id=62b5e78e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5e78e",
  null
  
)

export default component.exports